export default {
  title: 'Sembra che tu sia offline',
  description:
    'Fai clic su «Ricarica pagina» e/o controlla la connessione a Internet per assicurarti di essere online 😊',
  custom_button: {
    reload: 'Ricarica pagina',
  },
};
